export function isAccountStatusDeactivated(status) {
  return status === false;
}

export const ACCOUNT_DEACTIVATED_MESSAGE =
  'Your account has been deactivated. Please contact admin.';
